import useTranslation from 'next-translate/useTranslation'

import * as Sentry from '@sentry/nextjs'

import { useTrial } from '../TrialProvider'

const CUI_DOMAIN = process.env.NEXT_PUBLIC_CUI_DOMAIN

export function TrialCui() {
	const { setShowCuiMessage, loadRecaptcha } = useTrial()

	const cuiDomain = process.env.NEXT_PUBLIC_CUI_DOMAIN

	const { t } = useTranslation('trials')

	if (!cuiDomain) {
		Sentry.captureException(new Error('NEXT_PUBLIC_CUI_DOMAIN is not set'))
	}

	const redirectToCui = () => {
		if (!CUI_DOMAIN) {
			Sentry.captureException(new Error('NEXT_PUBLIC_CUI_DOMAIN is not set'))

			return
		}

		window.location.assign(CUI_DOMAIN)
	}

	return (
		<div className="text-center text-bc-black pt-8 lg:pt-12">
			<h2 className="text-2xl font-medium">{t('trialForm.status.cui.headline')}</h2>
			<p className="py-6">{t('trialForm.status.cui.body')} </p>

			<div className="flex justify-center items-center gap-6">
				<button
					type="button"
					onClick={() => redirectToCui()}
					className="py-2 px-6 rounded-md bg-bc-blue hover:bg-blue-200 text-white font-medium"
				>
					{t('trialForm.status.cui.buttons.redirect')}
				</button>

				<button
					type="button"
					onClick={() => {
						setShowCuiMessage(false)
						loadRecaptcha()
					}}
					className="border-2 py-2 px-6 rounded-md border-bc-black text-bc-black font-medium"
				>
					{t('trialForm.status.cui.buttons.cancel')}
				</button>
			</div>
		</div>
	)
}
